export const COUNTRY_CODES = [
  {
    label: 'Ascension Island',
    phoneCode: '+247',
    countryCode: 'AC',
    value: 'Ascension Island +247',
  },
  {
    label: 'Andorra',
    phoneCode: '+376',
    countryCode: 'AD',
    value: 'Andorra +376',
  },
  {
    label: 'United Arab Emirates',
    phoneCode: '+971',
    countryCode: 'AE',
    value: 'United Arab Emirates +971',
  },
  {
    label: 'Afghanistan',
    phoneCode: '+93',
    countryCode: 'AF',
    value: 'Afghanistan +93',
  },
  {
    label: 'Antigua & Barbuda',
    phoneCode: '+1',
    countryCode: 'AG',
    value: 'Antigua & Barbuda +1',
  },
  {
    label: 'Anguilla',
    phoneCode: '+1',
    countryCode: 'AI',
    value: 'Anguilla +1',
  },
  {
    label: 'Albania',
    phoneCode: '+355',
    countryCode: 'AL',
    value: 'Albania +355',
  },
  {
    label: 'Armenia',
    phoneCode: '+374',
    countryCode: 'AM',
    value: 'Armenia +374',
  },
  {
    label: 'Angola',
    phoneCode: '+244',
    countryCode: 'AO',
    value: 'Angola +244',
  },
  {
    label: 'Argentina',
    phoneCode: '+54',
    countryCode: 'AR',
    value: 'Argentina +54',
  },
  {
    label: 'American Samoa',
    phoneCode: '+1',
    countryCode: 'AS',
    value: 'American Samoa +1',
  },
  {
    label: 'Austria',
    phoneCode: '+43',
    countryCode: 'AT',
    value: 'Austria +43',
  },
  {
    label: 'Australia',
    phoneCode: '+61',
    countryCode: 'AU',
    value: 'Australia +61',
  },
  {
    label: 'Aruba',
    phoneCode: '+297',
    countryCode: 'AW',
    value: 'Aruba +297',
  },
  {
    label: 'Åland Islands',
    phoneCode: '+358',
    countryCode: 'AX',
    value: 'Åland Islands +358',
  },
  {
    label: 'Azerbaijan',
    phoneCode: '+994',
    countryCode: 'AZ',
    value: 'Azerbaijan +994',
  },
  {
    label: 'Bosnia & Herzegovina',
    phoneCode: '+387',
    countryCode: 'BA',
    value: 'Bosnia & Herzegovina +387',
  },
  {
    label: 'Barbados',
    phoneCode: '+1',
    countryCode: 'BB',
    value: 'Barbados +1',
  },
  {
    label: 'Bangladesh',
    phoneCode: '+880',
    countryCode: 'BD',
    value: 'Bangladesh +880',
  },
  {
    label: 'Belgium',
    phoneCode: '+32',
    countryCode: 'BE',
    value: 'Belgium +32',
  },
  {
    label: 'Burkina Faso',
    phoneCode: '+226',
    countryCode: 'BF',
    value: 'Burkina Faso +226',
  },
  {
    label: 'Bulgaria',
    phoneCode: '+359',
    countryCode: 'BG',
    value: 'Bulgaria +359',
  },
  {
    label: 'Bahrain',
    phoneCode: '+973',
    countryCode: 'BH',
    value: 'Bahrain +973',
  },
  {
    label: 'Burundi',
    phoneCode: '+257',
    countryCode: 'BI',
    value: 'Burundi +257',
  },
  {
    label: 'Benin',
    phoneCode: '+229',
    countryCode: 'BJ',
    value: 'Benin +229',
  },
  {
    label: 'St. Barthélemy',
    phoneCode: '+590',
    countryCode: 'BL',
    value: 'St. Barthélemy +590',
  },
  {
    label: 'Bermuda',
    phoneCode: '+1',
    countryCode: 'BM',
    value: 'Bermuda +1',
  },
  {
    label: 'Brunei',
    phoneCode: '+673',
    countryCode: 'BN',
    value: 'Brunei +673',
  },
  {
    label: 'Bolivia',
    phoneCode: '+591',
    countryCode: 'BO',
    value: 'Bolivia +591',
  },
  {
    label: 'Caribbean Netherlands',
    phoneCode: '+599',
    countryCode: 'BQ',
    value: 'Caribbean Netherlands +599',
  },
  {
    label: 'Brazil',
    phoneCode: '+55',
    countryCode: 'BR',
    value: 'Brazil +55',
  },
  {
    label: 'Bahamas',
    phoneCode: '+1',
    countryCode: 'BS',
    value: 'Bahamas +1',
  },
  {
    label: 'Bhutan',
    phoneCode: '+975',
    countryCode: 'BT',
    value: 'Bhutan +975',
  },
  {
    label: 'Botswana',
    phoneCode: '+267',
    countryCode: 'BW',
    value: 'Botswana +267',
  },
  {
    label: 'Belarus',
    phoneCode: '+375',
    countryCode: 'BY',
    value: 'Belarus +375',
  },
  {
    label: 'Belize',
    phoneCode: '+501',
    countryCode: 'BZ',
    value: 'Belize +501',
  },
  {
    label: 'Canada',
    phoneCode: '+1',
    countryCode: 'CA',
    value: 'Canada +1',
  },
  {
    label: 'Cocos  Islands',
    phoneCode: '+61',
    countryCode: 'CC',
    value: 'Cocos  Islands +61',
  },
  {
    label: 'Congo - Kinshasa',
    phoneCode: '+243',
    countryCode: 'CD',
    value: 'Congo - Kinshasa +243',
  },
  {
    label: 'Central African Republic',
    phoneCode: '+236',
    countryCode: 'CF',
    value: 'Central African Republic +236',
  },
  {
    label: 'Congo - Brazzaville',
    phoneCode: '+242',
    countryCode: 'CG',
    value: 'Congo - Brazzaville +242',
  },
  {
    label: 'Switzerland',
    phoneCode: '+41',
    countryCode: 'CH',
    value: 'Switzerland +41',
  },
  {
    label: 'Côte d’Ivoire',
    phoneCode: '+225',
    countryCode: 'CI',
    value: 'Côte d’Ivoire +225',
  },
  {
    label: 'Cook Islands',
    phoneCode: '+682',
    countryCode: 'CK',
    value: 'Cook Islands +682',
  },
  {
    label: 'Chile',
    phoneCode: '+56',
    countryCode: 'CL',
    value: 'Chile +56',
  },
  {
    label: 'Cameroon',
    phoneCode: '+237',
    countryCode: 'CM',
    value: 'Cameroon +237',
  },
  {
    label: 'China',
    phoneCode: '+86',
    countryCode: 'CN',
    value: 'China +86',
  },
  {
    label: 'Colombia',
    phoneCode: '+57',
    countryCode: 'CO',
    value: 'Colombia +57',
  },
  {
    label: 'Costa Rica',
    phoneCode: '+506',
    countryCode: 'CR',
    value: 'Costa Rica +506',
  },
  {
    label: 'Cuba',
    phoneCode: '+53',
    countryCode: 'CU',
    value: 'Cuba +53',
  },
  {
    label: 'Cape Verde',
    phoneCode: '+238',
    countryCode: 'CV',
    value: 'Cape Verde +238',
  },
  {
    label: 'Curaçao',
    phoneCode: '+599',
    countryCode: 'CW',
    value: 'Curaçao +599',
  },
  {
    label: 'Christmas Island',
    phoneCode: '+61',
    countryCode: 'CX',
    value: 'Christmas Island +61',
  },
  {
    label: 'Cyprus',
    phoneCode: '+357',
    countryCode: 'CY',
    value: 'Cyprus +357',
  },
  {
    label: 'Czechia',
    phoneCode: '+420',
    countryCode: 'CZ',
    value: 'Czechia +420',
  },
  {
    label: 'Germany',
    phoneCode: '+49',
    countryCode: 'DE',
    value: 'Germany +49',
  },
  {
    label: 'Djibouti',
    phoneCode: '+253',
    countryCode: 'DJ',
    value: 'Djibouti +253',
  },
  {
    label: 'Denmark',
    phoneCode: '+45',
    countryCode: 'DK',
    value: 'Denmark +45',
  },
  {
    label: 'Dominica',
    phoneCode: '+1',
    countryCode: 'DM',
    value: 'Dominica +1',
  },
  {
    label: 'Dominican Republic',
    phoneCode: '+1',
    countryCode: 'DO',
    value: 'Dominican Republic +1',
  },
  {
    label: 'Algeria',
    phoneCode: '+213',
    countryCode: 'DZ',
    value: 'Algeria +213',
  },
  {
    label: 'Ecuador',
    phoneCode: '+593',
    countryCode: 'EC',
    value: 'Ecuador +593',
  },
  {
    label: 'Estonia',
    phoneCode: '+372',
    countryCode: 'EE',
    value: 'Estonia +372',
  },
  {
    label: 'Egypt',
    phoneCode: '+20',
    countryCode: 'EG',
    value: 'Egypt +20',
  },
  {
    label: 'Western Sahara',
    phoneCode: '+212',
    countryCode: 'EH',
    value: 'Western Sahara +212',
  },
  {
    label: 'Eritrea',
    phoneCode: '+291',
    countryCode: 'ER',
    value: 'Eritrea +291',
  },
  {
    label: 'Spain',
    phoneCode: '+34',
    countryCode: 'ES',
    value: 'Spain +34',
  },
  {
    label: 'Ethiopia',
    phoneCode: '+251',
    countryCode: 'ET',
    value: 'Ethiopia +251',
  },
  {
    label: 'Finland',
    phoneCode: '+358',
    countryCode: 'FI',
    value: 'Finland +358',
  },
  {
    label: 'Fiji',
    phoneCode: '+679',
    countryCode: 'FJ',
    value: 'Fiji +679',
  },
  {
    label: 'Falkland Islands ',
    phoneCode: '+500',
    countryCode: 'FK',
    value: 'Falkland Islands  +500',
  },
  {
    label: 'Micronesia',
    phoneCode: '+691',
    countryCode: 'FM',
    value: 'Micronesia +691',
  },
  {
    label: 'Faroe Islands',
    phoneCode: '+298',
    countryCode: 'FO',
    value: 'Faroe Islands +298',
  },
  {
    label: 'France',
    phoneCode: '+33',
    countryCode: 'FR',
    value: 'France +33',
  },
  {
    label: 'Gabon',
    phoneCode: '+241',
    countryCode: 'GA',
    value: 'Gabon +241',
  },
  {
    label: 'United Kingdom',
    phoneCode: '+44',
    countryCode: 'GB',
    value: 'United Kingdom +44',
  },
  {
    label: 'Grenada',
    phoneCode: '+1',
    countryCode: 'GD',
    value: 'Grenada +1',
  },
  {
    label: 'Georgia',
    phoneCode: '+995',
    countryCode: 'GE',
    value: 'Georgia +995',
  },
  {
    label: 'French Guiana',
    phoneCode: '+594',
    countryCode: 'GF',
    value: 'French Guiana +594',
  },
  {
    label: 'Guernsey',
    phoneCode: '+44',
    countryCode: 'GG',
    value: 'Guernsey +44',
  },
  {
    label: 'Ghana',
    phoneCode: '+233',
    countryCode: 'GH',
    value: 'Ghana +233',
  },
  {
    label: 'Gibraltar',
    phoneCode: '+350',
    countryCode: 'GI',
    value: 'Gibraltar +350',
  },
  {
    label: 'Greenland',
    phoneCode: '+299',
    countryCode: 'GL',
    value: 'Greenland +299',
  },
  {
    label: 'Gambia',
    phoneCode: '+220',
    countryCode: 'GM',
    value: 'Gambia +220',
  },
  {
    label: 'Guinea',
    phoneCode: '+224',
    countryCode: 'GN',
    value: 'Guinea +224',
  },
  {
    label: 'Guadeloupe',
    phoneCode: '+590',
    countryCode: 'GP',
    value: 'Guadeloupe +590',
  },
  {
    label: 'Equatorial Guinea',
    phoneCode: '+240',
    countryCode: 'GQ',
    value: 'Equatorial Guinea +240',
  },
  {
    label: 'Greece',
    phoneCode: '+30',
    countryCode: 'GR',
    value: 'Greece +30',
  },
  {
    label: 'Guatemala',
    phoneCode: '+502',
    countryCode: 'GT',
    value: 'Guatemala +502',
  },
  {
    label: 'Guam',
    phoneCode: '+1',
    countryCode: 'GU',
    value: 'Guam +1',
  },
  {
    label: 'Guinea-Bissau',
    phoneCode: '+245',
    countryCode: 'GW',
    value: 'Guinea-Bissau +245',
  },
  {
    label: 'Guyana',
    phoneCode: '+592',
    countryCode: 'GY',
    value: 'Guyana +592',
  },
  {
    label: 'Hong Kong',
    phoneCode: '+852',
    countryCode: 'HK',
    value: 'Hong Kong +852',
  },
  {
    label: 'Honduras',
    phoneCode: '+504',
    countryCode: 'HN',
    value: 'Honduras +504',
  },
  {
    label: 'Croatia',
    phoneCode: '+385',
    countryCode: 'HR',
    value: 'Croatia +385',
  },
  {
    label: 'Haiti',
    phoneCode: '+509',
    countryCode: 'HT',
    value: 'Haiti +509',
  },
  {
    label: 'Hungary',
    phoneCode: '+36',
    countryCode: 'HU',
    value: 'Hungary +36',
  },
  {
    label: 'Indonesia',
    phoneCode: '+62',
    countryCode: 'ID',
    value: 'Indonesia +62',
  },
  {
    label: 'Ireland',
    phoneCode: '+353',
    countryCode: 'IE',
    value: 'Ireland +353',
  },
  {
    label: 'Israel',
    phoneCode: '+972',
    countryCode: 'IL',
    value: 'Israel +972',
  },
  {
    label: 'Isle of Man',
    phoneCode: '+44',
    countryCode: 'IM',
    value: 'Isle of Man +44',
  },
  {
    label: 'India',
    phoneCode: '+91',
    countryCode: 'IN',
    value: 'India +91',
  },
  {
    label: 'British Indian Ocean Territory',
    phoneCode: '+246',
    countryCode: 'IO',
    value: 'British Indian Ocean Territory +246',
  },
  {
    label: 'Iraq',
    phoneCode: '+964',
    countryCode: 'IQ',
    value: 'Iraq +964',
  },
  {
    label: 'Iran',
    phoneCode: '+98',
    countryCode: 'IR',
    value: 'Iran +98',
  },
  {
    label: 'Iceland',
    phoneCode: '+354',
    countryCode: 'IS',
    value: 'Iceland +354',
  },
  {
    label: 'Italy',
    phoneCode: '+39',
    countryCode: 'IT',
    value: 'Italy +39',
  },
  {
    label: 'Jersey',
    phoneCode: '+44',
    countryCode: 'JE',
    value: 'Jersey +44',
  },
  {
    label: 'Jamaica',
    phoneCode: '+1',
    countryCode: 'JM',
    value: 'Jamaica +1',
  },
  {
    label: 'Jordan',
    phoneCode: '+962',
    countryCode: 'JO',
    value: 'Jordan +962',
  },
  {
    label: 'Japan',
    phoneCode: '+81',
    countryCode: 'JP',
    value: 'Japan +81',
  },
  {
    label: 'Kenya',
    phoneCode: '+254',
    countryCode: 'KE',
    value: 'Kenya +254',
  },
  {
    label: 'Kyrgyzstan',
    phoneCode: '+996',
    countryCode: 'KG',
    value: 'Kyrgyzstan +996',
  },
  {
    label: 'Cambodia',
    phoneCode: '+855',
    countryCode: 'KH',
    value: 'Cambodia +855',
  },
  {
    label: 'Kiribati',
    phoneCode: '+686',
    countryCode: 'KI',
    value: 'Kiribati +686',
  },
  {
    label: 'Comoros',
    phoneCode: '+269',
    countryCode: 'KM',
    value: 'Comoros +269',
  },
  {
    label: 'St. Kitts & Nevis',
    phoneCode: '+1',
    countryCode: 'KN',
    value: 'St. Kitts & Nevis +1',
  },
  {
    label: 'North Korea',
    phoneCode: '+850',
    countryCode: 'KP',
    value: 'North Korea +850',
  },
  {
    label: 'South Korea',
    phoneCode: '+82',
    countryCode: 'KR',
    value: 'South Korea +82',
  },
  {
    label: 'Kuwait',
    phoneCode: '+965',
    countryCode: 'KW',
    value: 'Kuwait +965',
  },
  {
    label: 'Cayman Islands',
    phoneCode: '+1',
    countryCode: 'KY',
    value: 'Cayman Islands +1',
  },
  {
    label: 'Kazakhstan',
    phoneCode: '+7',
    countryCode: 'KZ',
    value: 'Kazakhstan +7',
  },
  {
    label: 'Laos',
    phoneCode: '+856',
    countryCode: 'LA',
    value: 'Laos +856',
  },
  {
    label: 'Lebanon',
    phoneCode: '+961',
    countryCode: 'LB',
    value: 'Lebanon +961',
  },
  {
    label: 'St. Lucia',
    phoneCode: '+1',
    countryCode: 'LC',
    value: 'St. Lucia +1',
  },
  {
    label: 'Liechtenstein',
    phoneCode: '+423',
    countryCode: 'LI',
    value: 'Liechtenstein +423',
  },
  {
    label: 'Sri Lanka',
    phoneCode: '+94',
    countryCode: 'LK',
    value: 'Sri Lanka +94',
  },
  {
    label: 'Liberia',
    phoneCode: '+231',
    countryCode: 'LR',
    value: 'Liberia +231',
  },
  {
    label: 'Lesotho',
    phoneCode: '+266',
    countryCode: 'LS',
    value: 'Lesotho +266',
  },
  {
    label: 'Lithuania',
    phoneCode: '+370',
    countryCode: 'LT',
    value: 'Lithuania +370',
  },
  {
    label: 'Luxembourg',
    phoneCode: '+352',
    countryCode: 'LU',
    value: 'Luxembourg +352',
  },
  {
    label: 'Latvia',
    phoneCode: '+371',
    countryCode: 'LV',
    value: 'Latvia +371',
  },
  {
    label: 'Libya',
    phoneCode: '+218',
    countryCode: 'LY',
    value: 'Libya +218',
  },
  {
    label: 'Morocco',
    phoneCode: '+212',
    countryCode: 'MA',
    value: 'Morocco +212',
  },
  {
    label: 'Monaco',
    phoneCode: '+377',
    countryCode: 'MC',
    value: 'Monaco +377',
  },
  {
    label: 'Moldova',
    phoneCode: '+373',
    countryCode: 'MD',
    value: 'Moldova +373',
  },
  {
    label: 'Montenegro',
    phoneCode: '+382',
    countryCode: 'ME',
    value: 'Montenegro +382',
  },
  {
    label: 'St. Martin',
    phoneCode: '+590',
    countryCode: 'MF',
    value: 'St. Martin +590',
  },
  {
    label: 'Madagascar',
    phoneCode: '+261',
    countryCode: 'MG',
    value: 'Madagascar +261',
  },
  {
    label: 'Marshall Islands',
    phoneCode: '+692',
    countryCode: 'MH',
    value: 'Marshall Islands +692',
  },
  {
    label: 'North Macedonia',
    phoneCode: '+389',
    countryCode: 'MK',
    value: 'North Macedonia +389',
  },
  {
    label: 'Mali',
    phoneCode: '+223',
    countryCode: 'ML',
    value: 'Mali +223',
  },
  {
    label: 'Myanmar ',
    phoneCode: '+95',
    countryCode: 'MM',
    value: 'Myanmar  +95',
  },
  {
    label: 'Mongolia',
    phoneCode: '+976',
    countryCode: 'MN',
    value: 'Mongolia +976',
  },
  {
    label: 'Macao',
    phoneCode: '+853',
    countryCode: 'MO',
    value: 'Macao +853',
  },
  {
    label: 'Northern Mariana Islands',
    phoneCode: '+1',
    countryCode: 'MP',
    value: 'Northern Mariana Islands +1',
  },
  {
    label: 'Martinique',
    phoneCode: '+596',
    countryCode: 'MQ',
    value: 'Martinique +596',
  },
  {
    label: 'Mauritania',
    phoneCode: '+222',
    countryCode: 'MR',
    value: 'Mauritania +222',
  },
  {
    label: 'Montserrat',
    phoneCode: '+1',
    countryCode: 'MS',
    value: 'Montserrat +1',
  },
  {
    label: 'Malta',
    phoneCode: '+356',
    countryCode: 'MT',
    value: 'Malta +356',
  },
  {
    label: 'Mauritius',
    phoneCode: '+230',
    countryCode: 'MU',
    value: 'Mauritius +230',
  },
  {
    label: 'Maldives',
    phoneCode: '+960',
    countryCode: 'MV',
    value: 'Maldives +960',
  },
  {
    label: 'Malawi',
    phoneCode: '+265',
    countryCode: 'MW',
    value: 'Malawi +265',
  },
  {
    label: 'Mexico',
    phoneCode: '+52',
    countryCode: 'MX',
    value: 'Mexico +52',
  },
  {
    label: 'Malaysia',
    phoneCode: '+60',
    countryCode: 'MY',
    value: 'Malaysia +60',
  },
  {
    label: 'Mozambique',
    phoneCode: '+258',
    countryCode: 'MZ',
    value: 'Mozambique +258',
  },
  {
    label: 'Namibia',
    phoneCode: '+264',
    countryCode: 'NA',
    value: 'Namibia +264',
  },
  {
    label: 'New Caledonia',
    phoneCode: '+687',
    countryCode: 'NC',
    value: 'New Caledonia +687',
  },
  {
    label: 'Niger',
    phoneCode: '+227',
    countryCode: 'NE',
    value: 'Niger +227',
  },
  {
    label: 'Norfolk Island',
    phoneCode: '+672',
    countryCode: 'NF',
    value: 'Norfolk Island +672',
  },
  {
    label: 'Nigeria',
    phoneCode: '+234',
    countryCode: 'NG',
    value: 'Nigeria +234',
  },
  {
    label: 'Nicaragua',
    phoneCode: '+505',
    countryCode: 'NI',
    value: 'Nicaragua +505',
  },
  {
    label: 'Netherlands',
    phoneCode: '+31',
    countryCode: 'NL',
    value: 'Netherlands +31',
  },
  {
    label: 'Norway',
    phoneCode: '+47',
    countryCode: 'NO',
    value: 'Norway +47',
  },
  {
    label: 'Nepal',
    phoneCode: '+977',
    countryCode: 'NP',
    value: 'Nepal +977',
  },
  {
    label: 'Nauru',
    phoneCode: '+674',
    countryCode: 'NR',
    value: 'Nauru +674',
  },
  {
    label: 'Niue',
    phoneCode: '+683',
    countryCode: 'NU',
    value: 'Niue +683',
  },
  {
    label: 'New Zealand',
    phoneCode: '+64',
    countryCode: 'NZ',
    value: 'New Zealand +64',
  },
  {
    label: 'Oman',
    phoneCode: '+968',
    countryCode: 'OM',
    value: 'Oman +968',
  },
  {
    label: 'Panama',
    phoneCode: '+507',
    countryCode: 'PA',
    value: 'Panama +507',
  },
  {
    label: 'Peru',
    phoneCode: '+51',
    countryCode: 'PE',
    value: 'Peru +51',
  },
  {
    label: 'French Polynesia',
    phoneCode: '+689',
    countryCode: 'PF',
    value: 'French Polynesia +689',
  },
  {
    label: 'Papua New Guinea',
    phoneCode: '+675',
    countryCode: 'PG',
    value: 'Papua New Guinea +675',
  },
  {
    label: 'Philippines',
    phoneCode: '+63',
    countryCode: 'PH',
    value: 'Philippines +63',
  },
  {
    label: 'Pakistan',
    phoneCode: '+92',
    countryCode: 'PK',
    value: 'Pakistan +92',
  },
  {
    label: 'Poland',
    phoneCode: '+48',
    countryCode: 'PL',
    value: 'Poland +48',
  },
  {
    label: 'St. Pierre & Miquelon',
    phoneCode: '+508',
    countryCode: 'PM',
    value: 'St. Pierre & Miquelon +508',
  },
  {
    label: 'Puerto Rico',
    phoneCode: '+1',
    countryCode: 'PR',
    value: 'Puerto Rico +1',
  },
  {
    label: 'Palestine',
    phoneCode: '+970',
    countryCode: 'PS',
    value: 'Palestine +970',
  },
  {
    label: 'Portugal',
    phoneCode: '+351',
    countryCode: 'PT',
    value: 'Portugal +351',
  },
  {
    label: 'Palau',
    phoneCode: '+680',
    countryCode: 'PW',
    value: 'Palau +680',
  },
  {
    label: 'Paraguay',
    phoneCode: '+595',
    countryCode: 'PY',
    value: 'Paraguay +595',
  },
  {
    label: 'Qatar',
    phoneCode: '+974',
    countryCode: 'QA',
    value: 'Qatar +974',
  },
  {
    label: 'Réunion',
    phoneCode: '+262',
    countryCode: 'RE',
    value: 'Réunion +262',
  },
  {
    label: 'Romania',
    phoneCode: '+40',
    countryCode: 'RO',
    value: 'Romania +40',
  },
  {
    label: 'Serbia',
    phoneCode: '+381',
    countryCode: 'RS',
    value: 'Serbia +381',
  },
  {
    label: 'Russia',
    phoneCode: '+7',
    countryCode: 'RU',
    value: 'Russia +7',
  },
  {
    label: 'Rwanda',
    phoneCode: '+250',
    countryCode: 'RW',
    value: 'Rwanda +250',
  },
  {
    label: 'Saudi Arabia',
    phoneCode: '+966',
    countryCode: 'SA',
    value: 'Saudi Arabia +966',
  },
  {
    label: 'Solomon Islands',
    phoneCode: '+677',
    countryCode: 'SB',
    value: 'Solomon Islands +677',
  },
  {
    label: 'Seychelles',
    phoneCode: '+248',
    countryCode: 'SC',
    value: 'Seychelles +248',
  },
  {
    label: 'Sudan',
    phoneCode: '+249',
    countryCode: 'SD',
    value: 'Sudan +249',
  },
  {
    label: 'Sweden',
    phoneCode: '+46',
    countryCode: 'SE',
    value: 'Sweden +46',
  },
  {
    label: 'Singapore',
    phoneCode: '+65',
    countryCode: 'SG',
    value: 'Singapore +65',
  },
  {
    label: 'St. Helena',
    phoneCode: '+290',
    countryCode: 'SH',
    value: 'St. Helena +290',
  },
  {
    label: 'Slovenia',
    phoneCode: '+386',
    countryCode: 'SI',
    value: 'Slovenia +386',
  },
  {
    label: 'Svalbard & Jan Mayen',
    phoneCode: '+47',
    countryCode: 'SJ',
    value: 'Svalbard & Jan Mayen +47',
  },
  {
    label: 'Slovakia',
    phoneCode: '+421',
    countryCode: 'SK',
    value: 'Slovakia +421',
  },
  {
    label: 'Sierra Leone',
    phoneCode: '+232',
    countryCode: 'SL',
    value: 'Sierra Leone +232',
  },
  {
    label: 'San Marino',
    phoneCode: '+378',
    countryCode: 'SM',
    value: 'San Marino +378',
  },
  {
    label: 'Senegal',
    phoneCode: '+221',
    countryCode: 'SN',
    value: 'Senegal +221',
  },
  {
    label: 'Somalia',
    phoneCode: '+252',
    countryCode: 'SO',
    value: 'Somalia +252',
  },
  {
    label: 'Suriname',
    phoneCode: '+597',
    countryCode: 'SR',
    value: 'Suriname +597',
  },
  {
    label: 'South Sudan',
    phoneCode: '+211',
    countryCode: 'SS',
    value: 'South Sudan +211',
  },
  {
    label: 'São Tomé & Príncipe',
    phoneCode: '+239',
    countryCode: 'ST',
    value: 'São Tomé & Príncipe +239',
  },
  {
    label: 'El Salvador',
    phoneCode: '+503',
    countryCode: 'SV',
    value: 'El Salvador +503',
  },
  {
    label: 'Sint Maarten',
    phoneCode: '+1',
    countryCode: 'SX',
    value: 'Sint Maarten +1',
  },
  {
    label: 'Syria',
    phoneCode: '+963',
    countryCode: 'SY',
    value: 'Syria +963',
  },
  {
    label: 'Eswatini',
    phoneCode: '+268',
    countryCode: 'SZ',
    value: 'Eswatini +268',
  },
  {
    label: 'Tristan da Cunha',
    phoneCode: '+290',
    countryCode: 'TA',
    value: 'Tristan da Cunha +290',
  },
  {
    label: 'Turks & Caicos Islands',
    phoneCode: '+1',
    countryCode: 'TC',
    value: 'Turks & Caicos Islands +1',
  },
  {
    label: 'Chad',
    phoneCode: '+235',
    countryCode: 'TD',
    value: 'Chad +235',
  },
  {
    label: 'Togo',
    phoneCode: '+228',
    countryCode: 'TG',
    value: 'Togo +228',
  },
  {
    label: 'Thailand',
    phoneCode: '+66',
    countryCode: 'TH',
    value: 'Thailand +66',
  },
  {
    label: 'Tajikistan',
    phoneCode: '+992',
    countryCode: 'TJ',
    value: 'Tajikistan +992',
  },
  {
    label: 'Tokelau',
    phoneCode: '+690',
    countryCode: 'TK',
    value: 'Tokelau +690',
  },
  {
    label: 'Timor-Leste',
    phoneCode: '+670',
    countryCode: 'TL',
    value: 'Timor-Leste +670',
  },
  {
    label: 'Turkmenistan',
    phoneCode: '+993',
    countryCode: 'TM',
    value: 'Turkmenistan +993',
  },
  {
    label: 'Tunisia',
    phoneCode: '+216',
    countryCode: 'TN',
    value: 'Tunisia +216',
  },
  {
    label: 'Tonga',
    phoneCode: '+676',
    countryCode: 'TO',
    value: 'Tonga +676',
  },
  {
    label: 'Turkey',
    phoneCode: '+90',
    countryCode: 'TR',
    value: 'Turkey +90',
  },
  {
    label: 'Trinidad & Tobago',
    phoneCode: '+1',
    countryCode: 'TT',
    value: 'Trinidad & Tobago +1',
  },
  {
    label: 'Tuvalu',
    phoneCode: '+688',
    countryCode: 'TV',
    value: 'Tuvalu +688',
  },
  {
    label: 'Taiwan',
    phoneCode: '+886',
    countryCode: 'TW',
    value: 'Taiwan +886',
  },
  {
    label: 'Tanzania',
    phoneCode: '+255',
    countryCode: 'TZ',
    value: 'Tanzania +255',
  },
  {
    label: 'Ukraine',
    phoneCode: '+380',
    countryCode: 'UA',
    value: 'Ukraine +380',
  },
  {
    label: 'Uganda',
    phoneCode: '+256',
    countryCode: 'UG',
    value: 'Uganda +256',
  },
  {
    label: 'United States',
    phoneCode: '+1',
    countryCode: 'US',
    value: 'United States +1',
  },
  {
    label: 'Uruguay',
    phoneCode: '+598',
    countryCode: 'UY',
    value: 'Uruguay +598',
  },
  {
    label: 'Uzbekistan',
    phoneCode: '+998',
    countryCode: 'UZ',
    value: 'Uzbekistan +998',
  },
  {
    label: 'Vatican City',
    phoneCode: '+39',
    countryCode: 'VA',
    value: 'Vatican City +39',
  },
  {
    label: 'St. Vincent & Grenadines',
    phoneCode: '+1',
    countryCode: 'VC',
    value: 'St. Vincent & Grenadines +1',
  },
  {
    label: 'Venezuela',
    phoneCode: '+58',
    countryCode: 'VE',
    value: 'Venezuela +58',
  },
  {
    label: 'British Virgin Islands',
    phoneCode: '+1',
    countryCode: 'VG',
    value: 'British Virgin Islands +1',
  },
  {
    label: 'U.S. Virgin Islands',
    phoneCode: '+1',
    countryCode: 'VI',
    value: 'U.S. Virgin Islands +1',
  },
  {
    label: 'Vietnam',
    phoneCode: '+84',
    countryCode: 'VN',
    value: 'Vietnam +84',
  },
  {
    label: 'Vanuatu',
    phoneCode: '+678',
    countryCode: 'VU',
    value: 'Vanuatu +678',
  },
  {
    label: 'Wallis & Futuna',
    phoneCode: '+681',
    countryCode: 'WF',
    value: 'Wallis & Futuna +681',
  },
  {
    label: 'Samoa',
    phoneCode: '+685',
    countryCode: 'WS',
    value: 'Samoa +685',
  },
  {
    label: 'Kosovo',
    phoneCode: '+383',
    countryCode: 'XK',
    value: 'Kosovo +383',
  },
  {
    label: 'Yemen',
    phoneCode: '+967',
    countryCode: 'YE',
    value: 'Yemen +967',
  },
  {
    label: 'Mayotte',
    phoneCode: '+262',
    countryCode: 'YT',
    value: 'Mayotte +262',
  },
  {
    label: 'South Africa',
    phoneCode: '+27',
    countryCode: 'ZA',
    value: 'South Africa +27',
  },
  {
    label: 'Zambia',
    phoneCode: '+260',
    countryCode: 'ZM',
    value: 'Zambia +260',
  },
  {
    label: 'Zimbabwe',
    phoneCode: '+263',
    countryCode: 'ZW',
    value: 'Zimbabwe +263',
  },
];
